import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAuth } from '../modules/auth'
import { getChatsHistory, getChatsRooms, sendMessage, updateMessage } from '../services/chats'
import { setMessages } from '../store/slice/ai-slice'

const useGetChats = (): {
    chatRooms: any[], getChatsHandler: () => Promise<unknown>, setChatRooms: any,
    getChatHistoryHandler: (roomId: string) => Promise<unknown>,
    sendMessageHandler: (payload: any,isUpdateRequest:boolean) => Promise<unknown>
} => {
    const dispatch = useDispatch()
    const [chatRooms, setChatRooms] = useState<any>([])
    const { currentUser } = useAuth()
    const { id } = currentUser?.data.user

    const getChatsHandler = async () => {
        try {
            const rooms: any = await getChatsRooms(id)
            setChatRooms(rooms.data.data)
        } catch (error) {
            return error
        }
    }
    const getChatHistoryHandler = async (roomId: string) => {
        try {
            const history: any = await getChatsHistory(roomId, id)
            dispatch(setMessages(history?.data?.data.history))
        } catch (error) {
            return error
        }
    }
    const sendMessageHandler = async (payload: any,isUpdateRequest:boolean) => {
        try {
            const msg: any = !isUpdateRequest ? await sendMessage(payload.chatId, payload) : await updateMessage(payload.chatId, payload);
            return msg
        } catch (error) {
            return error
        }
    }


    return { chatRooms, getChatsHandler, setChatRooms, getChatHistoryHandler, sendMessageHandler }
}

export default useGetChats
